import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { ContentContainer, VanillaBackground } from "@faire/retailer-visitor-shared/views/about/components/common";
import { ImageContent } from "@faire/retailer-visitor-shared/views/about/components/ImageContent";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var ImageModuleBase = function() {
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var spacer1Width = useResponsiveValue({
        mobileAndAbove: 0,
        desktopAndAbove: 120,
        xLargeAndAbove: 144
    });
    var spacer2Height = useResponsiveValue({
        mobileAndAbove: 72,
        tabletAndAbove: 88,
        desktopAndAbove: 0
    });
    var spacer3Height = useResponsiveValue({
        mobileAndAbove: 64,
        tabletAndAbove: 88,
        desktopAndAbove: 0
    });
    var spacer4Height = useResponsiveValue({
        mobileAndAbove: 24,
        desktopAndAbove: 16
    });
    return /*#__PURE__*/ _jsx(VanillaBackground, {
        children: /*#__PURE__*/ _jsxs(ContentContainer, {
            children: [
                isDesktopAndAbove ? /*#__PURE__*/ _jsx(Spacer, {
                    height: 120
                }) : null,
                /*#__PURE__*/ _jsxs(TextImage, {
                    $reverse: true,
                    children: [
                        isDesktopAndAbove ? /*#__PURE__*/ _jsx(SlideIn, {
                            offset: "70px",
                            children: /*#__PURE__*/ _jsx(ImageContent, {
                                description: "Store Entrance"
                            })
                        }) : /*#__PURE__*/ _jsx(ImageContent, {
                            description: "Store Entrance"
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: spacer1Width
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: spacer2Height
                                }),
                                /*#__PURE__*/ _jsx(SlideIn, {
                                    offset: "50px",
                                    children: /*#__PURE__*/ _jsx(Heading, {
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "xC9Jzm",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "We believe the future is local"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: isDesktopAndAbove ? "2x" : "3x"
                                }),
                                /*#__PURE__*/ _jsx(SlideIn, {
                                    offset: "70px",
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subheadingSansRegular",
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "vTVPpL",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Now more than ever, consumers are choosing to support local shops over big-box chains. There are millions of thriving small businesses in North America, Europe, and Australia alone, who collectively represent a multi-hundred-billion-dollar market. With our global community and the power of technology, Faire is helping fuel the growth of entrepreneurs everywhere."
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: spacer3Height
                                })
                            ]
                        })
                    ]
                }),
                isDesktopAndAbove ? /*#__PURE__*/ _jsx(Spacer, {
                    height: 104
                }) : null,
                /*#__PURE__*/ _jsxs(TextImage, {
                    children: [
                        isDesktopAndAbove ? /*#__PURE__*/ _jsx(SlideIn, {
                            offset: "70px",
                            children: /*#__PURE__*/ _jsx(ImageContent, {
                                description: "Person Candle"
                            })
                        }) : /*#__PURE__*/ _jsx(ImageContent, {
                            description: "Person Candle"
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: spacer1Width
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: spacer2Height
                                }),
                                /*#__PURE__*/ _jsx(SlideIn, {
                                    offset: "50px",
                                    children: /*#__PURE__*/ _jsx(Heading, {
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "bYef24",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "And we\u2019re just getting started"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: spacer4Height
                                }),
                                /*#__PURE__*/ _jsxs(SlideIn, {
                                    offset: "50px",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subheadingSansRegular",
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "bKw1lJ",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "We created Faire in 2017 with a simple vision: to help small businesses come together to compete on a more level playing field with the likes of Walmart and Amazon. Today, Faire is the online marketplace where retailers discover their next bestsellers from independent brands across the globe."
                                                    }
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            height: "2x"
                                        }),
                                        /*#__PURE__*/ _jsxs(LinkContainer, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    variant: "tertiary",
                                                    linkTo: "https://news.faire.com/2021/06/10/independent-retails-resilience/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Typography, {
                                                        variant: "subheadingSansRegular",
                                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                            id: "RW1L9C",
                                                            defaultMessage: [
                                                                {
                                                                    type: 0,
                                                                    value: "More from Max Rhodes, CEO"
                                                                }
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Spacer, {
                                                    width: "1x"
                                                }),
                                                /*#__PURE__*/ _jsx(ArrowContainer, {
                                                    children: /*#__PURE__*/ _jsx(Arrow, {
                                                        direction: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: spacer3Height
                                })
                            ]
                        })
                    ]
                }),
                isDesktopAndAbove ? /*#__PURE__*/ _jsx(Spacer, {
                    height: 120
                }) : null
            ]
        })
    });
};
export var ImageModule = observer(ImageModuleBase);
var TextImage = styled.div.withConfig({
    componentId: "sc-7cc41bb0-0"
})([
    "display:flex;flex-direction:column;justify-content:space-around;",
    "{flex-direction:",
    ";align-items:center;}"
], responsiveMediaQueries.desktopAndAbove, function(props) {
    return props.$reverse ? "row-reverse" : "row";
});
var ArrowContainer = styled.div.withConfig({
    componentId: "sc-7cc41bb0-1"
})([
    "transition:0.5s ease;"
]);
var LinkContainer = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-7cc41bb0-2"
})([
    "&:hover{",
    "{transform:translate(10px);}}"
], ArrowContainer);
var Heading = styled(Typography).attrs({
    variant: "displayMSerifRegular"
}).withConfig({
    componentId: "sc-7cc41bb0-3"
})([
    "",
    "{width:60%;}"
], responsiveMediaQueries.desktopAndAbove);
